import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { Router } from '@angular/router';
import { Lightbox } from 'ngx-lightbox';
import { SUB_PROJECT_TYPES } from 'src/app/model/project/sub-project';
import DateHelper from '../../../../helpers/date-helper';
import { SubProjectImmoDesign } from '../../../../model/project/sub-project-immo-design';
import { SubProjectControllerRequestService } from '../../../../services/api/sub-project-controller-request.service';
import { FilterStoreService } from '../../../../services/filter-store.service';
import { ModalService } from '../../../../services/modal.service';
import { PageIndexService } from '../../../../services/page-index-service';
import { SnackService } from '../../../../services/snack.service';
import { AbstractImmoOverviewComponent } from '../abstract-immo-overview.component';

@Component({
  selector: 'design-immo-overview',
  templateUrl: '../abstract-immo-overview.component.html',
  styleUrls: ['../abstract-immo-overview.component.scss'],
})
export class DesignImmoOverviewComponent extends AbstractImmoOverviewComponent<SubProjectImmoDesign> {
  @Output()
  countChange = new EventEmitter<number>();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    protected filterStoreService: FilterStoreService,
    protected pageIndexService: PageIndexService,
    protected cd: ChangeDetectorRef,
    protected subProjectService: SubProjectControllerRequestService,
    protected _lightbox: Lightbox,
    protected router: Router,
    private snackService: SnackService,
    private modalService: ModalService
  ) {
    super(
      [
        {
          key: 'project__id',
          active: false,
          strictEquality: true,
          numeric: true,
        },
        {
          key: 'currentCreatedAt',
          active: false,
          strictEquality: true,
          numeric: false,
        },
        {
          key: 'immoNewCustomerName',
          active: false,
          strictEquality: false,
          numeric: false,
        },
      ],
      filterStoreService,
      pageIndexService,
      cd,
      subProjectService,
      _lightbox,
      router
    );
  }

  protected getPaginator(): MatPaginator {
    return this.paginator;
  }

  protected initDisplayedColumns(): void {
    this.displayedColumns = [
      'projectId',
      'request',
      'deadlineIpBoard',
      'customerName',
      'needsDesignDescription',
      'kind',
      'measurements',
      'type',
      'designer',
      'designSent',
      'displayStatus',
      'dropdownActions',
    ];
  }

  public openTour(subProject: SubProjectImmoDesign): void {
    throw new Error('Method not implemented.');
  }
  public copyProjectId(subProject: SubProjectImmoDesign): void {
    throw new Error('Method not implemented.');
  }

  protected initSortSettings(): void {
    this.sortColumn = 'currentCreatedAt';
    this.sortAscending = false;
  }

  protected fetchItems(): void {
    this.loading = true;
    this.items = [];

    this.subProjectService
      .getImmoDesign(
        this.generateFilterString(),
        this.sortColumn,
        this.sortAscending,
        this.paginator.pageSize,
        this.paginator.pageIndex,
        false
      )
      .then((res) => {
        this.processPageResult(res);
        this.totalItems = res.totalItems;
        this.countChange.emit(this.totalItems);
        this.items = this.parseFetchedItems(res.items);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private parseFetchedItems(
    items: SubProjectImmoDesign[]
  ): SubProjectImmoDesign[] {
    for (const item of items) {
      if (item.currentCreatedAt != null) {
        item.currentCreatedAtDisplay = DateHelper.formatDate(
          item.currentCreatedAt
        );
      }
      if (item.project.ipBoards != null && item.project.ipBoards.length > 0) {
        item.project.firstIpBoard = item.project.ipBoards[0];
        if (item.project.firstIpBoard.designSentRegistrationDate != null) {
          item.project.firstIpBoard.designSentRegistrationDateDisplay =
            DateHelper.formatDate(
              item.project.firstIpBoard.designSentRegistrationDate
            );
        }
      }

      if (item.type !== SUB_PROJECT_TYPES.BASE_PROJECT) {
        item.designSentRegistrationDateDisplay = DateHelper.formatDate(
          item.designSentRegistrationDate
        );
      }
    }

    return items;
  }

  public openProject(subProject: SubProjectImmoDesign) {
    this.router.navigate([
      '/project',
      subProject.project == null ? null : subProject.project.id,
      subProject.id,
    ]);
  }

  protected getLocalStorageKey(): string {
    return 'DesignImmoOverviewComponent';
  }

  public archive(subProject: SubProjectImmoDesign): void {
    this.modalService.confirmDialog(
      'Verwijderen',
      'Weet u zeker dat u deze job wilt verwijderen?',
      (c) => {
        if (c) {
          this.subProjectService.archive(subProject.id).then(() => {
            this.snackService.showSuccess('Verwijdering succesvol');
            this.fetchItems();
          });
        }
      }
    );
  }
}
